import createStore from 'picostate'
import initialState from './initialState.js'

export default createStore(initialState)
